import {instanceOf} from "prop-types";
import {Cookies, withCookies} from "react-cookie";
import Menu from "../components/Menu/Menu";
import {Link, withRouter} from "react-router-dom";
import betaLogo from '../images/alumsumlogotm.png';
import {Button} from "reactstrap";
import React, {Component} from 'react';
import LogoVertical from "../art/images/vertical-logo.png";
import Oval from "../art/images/Oval Copy 4.jpg";
import Fill from "../art/images/Fill 1.png";
import Path from "../art/images/Path.png";
import SpinWheelLogo from "../art/images/spinwheelLogo.png";
import "./loans.scss";
import Footer from '../Footer';

class OnboardingLoansSpinwheel extends Component{

    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) {
        super(props);
        const {cookies} = props;
        this.state = {
            loading: false,
            error: null,
            extUserId: null,
            token: null,
            refreshToken: null,
            csrfToken: cookies.get('XSRF-TOKEN')
        };

    }
    async componentDidMount() {
        await fetch('/alumsum/spinwheelInfo', {credentials: 'include'})
            .then(async response => {
                const data = await response.json();
                const spinwheelKey = process.env.REACT_APP_PROD_SPINWHEEL_KEY;
                console.log("user info returned: ", data);
                this.setState({extUserId: data.extUserId})
                this.setState({token: data.userToken})
                this.setState({refreshToken: data.userRefreshToken})

                const Spinwheel = window.Spinwheel;
            })
            .then(data => this.setState({isLoaded: true})
            );
    }


    render(){
        const {item,isLoaded} = this.state;
        if(isLoaded) {
            return (
                <div className="loanContainer">
                    <div className="app-content display-flex h-100">
                        {/*<Menu data={this.state}></Menu>*/}
                        <div id="main-content" className="main-container wd-100">
                            <Link to="/alumsum/dashboard"><img src={betaLogo} alt="logo" className="responsiveLogo"/></Link>
                            <div className="stepperline">
                                <br>

                                </br>
                                <div className="onboardloansrectangle spinwheelRectangle">

                                    <div className="We-need-your-loan-in">
                                        <p>We need your loan info so we show graphs and charts related to
                                            your loans, payoff timelines, and savings calculations.</p>
                                        <div className="loanlogo">
                                            <div className="outerLogo">
                                                <img src={LogoVertical} alt="logo"/>
                                            </div>
                                            <div className="ovalRow">
                                                <img src={Oval} alt="oval" className="Oval-Copy outer"/>
                                                <img src={Oval} alt="oval" className="Oval-Copy"/>
                                                <img src={Oval} alt="oval" className="Oval-Copy outer"/>
                                            </div>
                                            <div className="finicity-logo">
                                                <img src={SpinWheelLogo} alt="finicity logo"/>
                                            </div>
                                            <div className="ovalRow">
                                                <img src={Oval} alt="oval" className="Oval-Copy outer"/>
                                                <img src={Oval} alt="oval" className="Oval-Copy"/>
                                                <img src={Oval} alt="oval" className="Oval-Copy outer"/>
                                            </div>
                                            <div className="outerLogo">
                                                <img src={Fill} alt="fill" className="fill1"/>
                                            </div>
                                        </div>
                                        <div className="usesPlaid">
                                            <p className="spinwheelLink">AlumSum uses <Link to={{ pathname: "https://spinwheel.io/"}} target="_blank">Spinwheel</Link> to connect your loans and
                                                accounts</p>
                                        </div>
                                        <div className="Secure">
                                            <img className="SecureCheckmark" src={Path} alt="path"/>
                                            <label className="SecureText"> <strong>Secure: </strong>Your information is encrypted end-to-end during transfer</label>
                                        </div>
                                        <div className="Secure">
                                            <img className="SecureCheckmark" src={Path} alt="path"/>
                                            <label className="SecureText"> <strong>Private: </strong>Your credentials will not be made accessible to Alumsum</label>
                                        </div>
                                        <div className="Secure">
                                            <img className="SecureCheckmark" src={Path} alt="path"/>
                                            <label className="SecureText"><strong>Fast: </strong>Connecting your accounts takes just seconds. </label>
                                        </div>
                                        <div className="addLoans">
                                            <p>You are about to add your student loans by clicking on the Spinwheel button below.</p>
                                            <div className="loanButtonRow">
                                                <div className="">
                                                    <Button className="spinwheelButton" href="/alumsum/spinwheel" >Add Loans
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <Footer/>
                </div>
            );
        } else {
            return (<div className="loanContainer"><h3>Loading...</h3></div>)
        }

    }
}
export default withCookies(withRouter(OnboardingLoansSpinwheel));